import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '../hooks';
import MobileLayout from '../pages/_layouts/mobile';

const MobileRoute = ({ component: Component, path, ...rest }) => {
  const { isLogged, isTokenExpired, signOut } = useAuth();
  const [isMobileLogin, setIsMobileLogin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [checkedAuth, setCheckedAuth] = useState(false);

  useEffect(() => {
    const loginSource = localStorage.getItem('@Diretiva:loginSource');
    const isMobileDomain =
      window.location.hostname === 'testes.cartefacile.com';
    // Se loginSource for mobile OU está em domínio mobile, libera
    const mobileLogin = loginSource === 'mobile' || isMobileDomain;
    setIsMobileLogin(mobileLogin);
    setIsChecking(false);

    // Sempre seta o cookie loginSource=mobile se estiver logado e na rota mobile
    if (mobileLogin && isLogged()) {
      // Se estiver no domínio proxy, seta o cookie para o domínio correto
      if (isMobileDomain) {
        document.cookie =
          'loginSource=mobile; path=/; max-age=86400; domain=.testes.cartefacile.com';
      } else {
        document.cookie = 'loginSource=mobile; path=/; max-age=86400';
      }
    } else {
      // Remove o cookie de ambos os domínios
      document.cookie =
        'loginSource=; path=/; max-age=0; domain=.testes.cartefacile.com';
      document.cookie = 'loginSource=; path=/; max-age=0';
    }
  }, [isLogged]);

  useEffect(() => {
    // Checa autenticação ao montar
    if (!isChecking) {
      setCheckedAuth(true);
    }
  }, [isChecking]);

  // Só faz signOut se o token realmente estiver expirado E o usuário estiver logado
  useEffect(() => {
    if (isLogged() && isTokenExpired()) {
      signOut();
    }
  }, [isLogged, isTokenExpired, signOut]);

  if (isChecking || !checkedAuth) {
    return <div className="loading-mobile">Carregando...</div>;
  }

  // Só redireciona se realmente não estiver logado ou token expirado
  if (!isLogged() || isTokenExpired()) {
    const currentPath = window.location.pathname;
    localStorage.setItem('@Diretiva:redirectAfterLogin', currentPath);
    // Remove cookie loginSource se deslogar
    document.cookie = 'loginSource=; path=/; max-age=0';
    return <Redirect to="/mobile-signin" />;
  }

  // Só bloqueia se não for domínio mobile E não tiver login mobile
  const isMobileDomain = window.location.hostname === 'testes.cartefacile.com';
  if (!isMobileLogin && !isMobileDomain) {
    toast.warn(
      'Esta área é exclusiva para acesso móvel. Faça login através da tela móvel.',
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      }
    );
    signOut();
    document.cookie = 'loginSource=; path=/; max-age=0';
    return <Redirect to="/mobile-signin" />;
  }

  return (
    <Route
      {...rest}
      render={props => (
        <MobileLayout>
          <Component {...props} />
        </MobileLayout>
      )}
    />
  );
};

export default MobileRoute;
